<template>
  <div>
    <el-select v-model="izbranSap"
               class="velikost-izbirnika-strank"
               :style="customStyle"
               placeholder="Izberite stranko"
               :disabled="disabled"
               no-data-text="Nimate povezanih naročnin"
               v-if="podatkiIzbirnika.length > 0">
      <el-option v-for="data in podatkiIzbirnika"
                 :key="data.id"
                 :label="podatkiIzbirnika.length === 1 ? data.naziv : (data.naziv + ' - '  + data.id)"
                 :value="data.id">
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import ClientAgent from '../../../../assets/js/clientAgent.js'
  import {GetPodatkiIzbirnika} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js'
  import {Select, Option} from 'element-ui'
  import {PridobiStranko} from 'src/assets/js/globalne_funkcije/PridobivanjeStranke/PridobiStranko'
  import {PrivzetaVrednostTipEnum} from '../../../../assets/js/Enum/PrivzetaVrednostTipEnum'
  import PrivzetaVrednostLogic from '../../../../assets/js/globalne_funkcije/PrivzetaVrednostLogic'
  export default {
    name: 'IzbirnikStranke',
    mixins: [GetPodatkiIzbirnika, PridobiStranko],
    data () {
      return {
        clientAgent: null,
        seznamStrank: [],
        podatkiIzbirnika: [],
        izbranSap: null,
        idStranka: null,
        podatkiStranke: [],
        nosilnaNarocnina: ''
      }
    },
    watch: {
      preloadNarocnina: function (val) {
        if (val !== null) {
          this.izbranSap = val.id_stranka_sap
        }
      },
      izbranSap: function () {
        if (typeof this.izbranSap !== 'undefined' && this.izbranSap !== null && this.izbranSap !== '') {
          for (let i = 0; i < this.seznamStrank.length; i++) {
            if (this.ParseStrankaSap(this.seznamStrank[i]) !== null) {
              this.seznamStrank[i].id_stranka_sap = this.ParseStrankaSap(this.seznamStrank[i])
              if (this.izbranSap === this.seznamStrank[i].id_stranka_sap) {
                this.idStranka = this.seznamStrank[i].id_stranka
                this.podatkiStranke = this.seznamStrank[i]
                this.$emit('osvezitevIzbranSap', this.izbranSap)
                this.$emit('osvezitevIzbranIdStranka', this.idStranka)
                this.$emit('osvezitevIzbranihPodatkovStranke', this.podatkiStranke)
              }
              if (this.seznamStrank[i].nosilec_narocnine === '1') {
                this.nosilnaNarocnina = this.seznamStrank[i]
              } else {
                this.nosilnaNarocnina = this.seznamStrank[0]
              }
              this.$emit('osvezitevIzbraneNosilneNarocine', this.nosilnaNarocnina)
            }
          }
        }
      }
    },
    props: {
      selectorPermissions: null,
      disabled: false,
      preloadNarocnina: null,
      filterObj: {
        type: Object,
        default: null
      },
      customStyle: ''
    },
    components: {
      [Option.name]: Option,
      [Select.name]: Select
    },
    mounted () {
      this.seznamStrank = []
      this.clientAgent = new ClientAgent()
      let param = {}
      param.vmesnik = this
      param.filter = this.filterObj
      param.permissions = this.selectorPermissions
      this.PridobiPodatkeIzbirnika(param)
    },
    methods: {
      ParseStrankaSap (podatkiStranke) {
        if (typeof podatkiStranke === 'object' && podatkiStranke !== null) {
          for (let [key, value] of Object.entries(podatkiStranke)) {
            if (key.indexOf('sap') !== -1) {
              return value
            }
          }
        }
        return null
      },
      PrenosniPodatki (podatki) {
        this.izbranSap = null
        this.seznamStrank = [...this.seznamStrank, ...podatki.data]
        this.podatkiIzbirnika = [...this.podatkiIzbirnika, ...podatki.selectorData]
        this.odstraniDupliciraneStrankeInPodatkeIzbirnika()
        if (this.seznamStrank.length > 0) {
          let shranjenPrivzetSap = PrivzetaVrednostLogic.getInstance().GetPrivzetaVrednost(PrivzetaVrednostTipEnum.SAP)
          if (shranjenPrivzetSap !== null) {
            if (this.StrankaObstajaVSeznamu(shranjenPrivzetSap)) {
              this.izbranSap = shranjenPrivzetSap
            } else { // ce sapa ni v seznamu, osvezi seznam
              this.GetUserData() // callback je PrenosniPodatkiStranka
            }
          } else {
            this.GetUserData() // callback je PrenosniPodatkiStranka
          }
        } else {
          this.$emit('niPodatkovPrikaza')
        }
      },
      PrenosniPodatkiStranka () {
        let defaultSap = PrivzetaVrednostLogic.getInstance().GetPrivzetaVrednost(PrivzetaVrednostTipEnum.SAP)
        if (this.StrankaObstajaVSeznamu(defaultSap)) {
          this.izbranSap = defaultSap
        } else if (this.seznamStrank.length > 0) {
          for (let i = 0; i < this.seznamStrank.length; i++) {
            let sap = this.seznamStrank[i].id_stranka_sap
            if (sap === undefined) { sap = this.seznamStrank[i].sap }
            if (typeof sap !== 'undefined') {
              this.izbranSap = this.ParseStrankaSap(this.seznamStrank[i])
            }
          }
        }
      },
      StrankaObstajaVSeznamu (iskanSap) {
        for (const index in this.seznamStrank) {
          if (this.ParseStrankaSap(this.seznamStrank[index]) === iskanSap) {
            return true
          }
        }
        return false
      },
      odstraniDupliciraneStrankeInPodatkeIzbirnika () {
        let privateVars = ['seznamStrank', 'podatkiIzbirnika']
        let seznamObstojecih = {}
        privateVars.forEach((type) => {
          if (seznamObstojecih[type] === undefined) {
            seznamObstojecih[type] = []
          }
          this[type].forEach((o) => {
            let exists = false
            let keyValue = type === 'podatkiIzbirnika' ? o.id : this.ParseStrankaSap(o)
            if (keyValue !== null) {
              seznamObstojecih[type].forEach((filtrirane) => {
                let obsKey = type === 'podatkiIzbirnika' ? filtrirane.id : this.ParseStrankaSap(filtrirane)
                if (obsKey === keyValue) {
                  exists = true
                }
              })
              if (!exists) {
                seznamObstojecih[type].push(o)
              }
            }
          })
        })
        this.seznamStrank = seznamObstojecih.seznamStrank
        this.podatkiIzbirnika = seznamObstojecih.podatkiIzbirnika
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/GlobalneKomponente/IzbirnikStranke.vue